<!-- Header Section -->
<header>
  <div class="header-holder">
    <!-- header Section -->
    <section class="header">
      <!-- <h1 class="logo">Kiko VPN</h1> -->
      <h1 class="logo">
        <img src="assets/icons/logo_white.png" alt="Kiko VPN Logo" class="logo-icon">
        Kiko VPN
      </h1>
      <nav class="navigation">
        <a href="/home">Home</a>
        <a href="/downloads">Downloads</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
        <a href="/reseller">Reseller</a>
        <a href="/faq">Faq</a>
        <a href="/support">Support</a>
        <a href="/about">About Us</a>
      </nav>
    </section>
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content">
        <h1 class="title">Secure & Fast VPN for Unlimited Freedom</h1>
        <p class="subtitle">
          Protect your privacy, unblock content, and browse safely with Kiko VPN.
        </p>
        <div class="cta-buttons">
          <button class="btn primary">Get Started</button>
          <button class="btn secondary">Learn More</button>
        </div>
      </div>
      <div class="hero-image">
        <img src="assets/images/hero_one.png" alt="VPN Illustration" />
      </div>
    </section>
  </div>
</header>

<div class="body-holder">
  <!-- Home Section -->
  <section class="home-section" id="home">
    <!-- Downloads Section -->
    <h3>Current Downloads</h3>
      <div class="download-platforms">
        <div class="platform">
          <img src="assets/icons/icon_android_os.png" alt="Android" class="platform-icon" />
          <p>{{ downloads.android }} downloads</p>
        </div>
        <div class="platform">
          <img src="assets/icons/icon_iphone_os.png" alt="iOS" class="platform-icon" />
          <p>{{ downloads.ios }} downloads</p>
        </div>
        <div class="platform">
          <img src="assets/icons/icon_windows_os.png" alt="Windows" class="platform-icon" />
          <p>{{ downloads.windows }} downloads</p>
        </div>
        <div class="platform">
          <img src="assets/icons/icon_mac_os.png" alt="macOS" class="platform-icon" />
          <p>{{ downloads.macos }} downloads</p>
        </div>
      </div>
  </section>
  <!-- Blogs Section -->
  <section class="blog-section" id="blogs">
    <script type='text/javascript' src='//pl26094371.effectiveratecpm.com/9b/0a/80/9b0a8044b2c9d2d90d5de17ae7e811a7.js'></script>
    <h3>Latest News & Blog Posts</h3>
    <div class="blog-container">
      <div *ngFor="let post of blogs; let i = index" class="blog-card">
        <img [src]="post.image_url" alt="Blog Image" class="blog-image" />
        <div class="blog-content">
          <h3 class="blog-title">{{ post.title }}</h3>
          <div class="blog-author">
            <p class="blog-name">{{ post.name }}</p>
            <p class="blog-date">{{getDateTime(post.created_at)}}</p>
          </div>
          <p class="blog-summary">{{ post.summary }}</p>
          <button (click)="showFullContent(i)" class="read-more">{{post.is_expanded ? 'Read Less' : 'Read More'}}</button>
          <div *ngIf="post.is_expanded" class="blog-full-content">
            <div data-nat='6063100'></div>
            <p>{{ post.blog }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
  
